<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="here px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">最終確認</h3>
    <p class="exp">
      以下の内容でよろしければ入会申込みを確定するを押してください。
    </p>

    <div class="form-order-confirm border box-p-20 my-5">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center">
          <p>商品</p>
        </div>
        <div class="shohin_quantity text-center">
          <p>個数</p>
        </div>
        <div class="shohin_price text-center">
          <p>価格</p>
        </div>
      </div>
      <div id="CartList">
        <ul>
          <ConfirmItem
            v-for="item in cart.goods"
            :key="item.no"
            :btotal="true"
            :item="item"
          ></ConfirmItem>
          <ConfirmItem
            v-for="item in cart.tools"
            :key="item.no"
            :btotal="true"
            :item="item"
          ></ConfirmItem>
          <ConfirmItem
            v-for="item in cart.camps"
            :key="item.no"
            :btotal="true"
            :item="item"
          ></ConfirmItem>
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>小計</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.ItemAmount }}円</p>
        </div>
      </div>
      <div class="style-d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>代金引換手数料</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.CollectFee }}円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>送料</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.CarriageFee }}円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>合計</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ cart.Total }}円</p>
        </div>
      </div>
      <div class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>付与予定ポイント</p>
          </div>
        <div class="shohin_price text-right">
          <p>{{point}}ポイント</p>
        </div>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/registration/order/confirm' }"
          class="btn d-inline-block"
        >
          カートに戻る
        </router-link>
      </div>
    </div>
    <div class="form-member border box-p-20 mb-5">
      <h3 class="mb-5 teext-left">お届け先、お届け日、お支払方法</h3>
      <div id="divDeliveryConfirm" class="inner">
        <dl style="margin-bottom: 0; border-bottom: 0">
          <dt>お受取りについて</dt>
          <dd>本人が受取ることを同意する</dd>
          <dt>お届け先</dt>
          <dd>{{ delivery.ToDelivery }}</dd>
        </dl>
        <dl
          v-if="delivery.ToDelivery == 'ご自宅以外'"
          style="margin-bottom: 0; border-bottom: 0"
        >
          <dt style="width: 100%; float: none; background: #fff">
            ※ご自宅以外のお届け先
          </dt>
          <dt>郵便番号</dt>
          <dd>{{ delivery.ZipCode2 }}</dd>
          <dt>住所</dt>
          <dd>{{ delivery.Part1OfAddress }}</dd>
          <dt>住所<span class="fs-08">（フリガナ）</span></dt>
          <dd>{{ delivery.AddressKana }}</dd>
          <dt>住所<span class="fs-08">（建物名）</span></dt>
          <dd>{{ delivery.Part2OfAddress }}</dd>
          <dt>宛先</dt>
          <dd>{{ delivery.Part3OfAddress }}</dd>
          <dt>電話番号</dt>
          <dd>{{ delivery.TelNo }}</dd>
        </dl>
        <dl>
          <dt>お届け指定日</dt>
          <dd>{{delivery.DeliveryDate}}</dd>
          <dt>お届け時間帯</dt>
          <dd>{{delivery.DeliveryTime}}</dd>
          <dt>お支払方法</dt>
          <dd>{{delivery.PaymentMethod}}</dd>
        </dl>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link
          :to="{ path: '/registration/delivery' }"
          class="btn d-inline-block"
        >
          お届け、お支払方法を変更する
        </router-link>
      </div>
    </div>
    <div class="form-member border box-p-20 mb-5">
      <div class="inner">
        <h3 class="mb-5 teext-left">申込者情報</h3>
        <dl id="divRegistrationConfirm">
          <!-- 動的生成部 -->
          <form>
            <dl id="dlConfirm">
              <dt>氏名</dt>
              <dd>{{ registration.Name1 }}&emsp;{{ registration.Name2 }}</dd>
              <dt>氏名<span class="fs-08">（フリガナ）</span></dt>
              <dd>
                {{ registration.NameKana1 }}&emsp;{{ registration.NameKana2 }}
              </dd>
              <dt>性別</dt>
              <dd>{{ registration.Sex }}</dd>
              <dt>配偶者</dt>
              <dd>{{ registration.Spouse }}</dd>
              <dt>生年月日</dt>
              <dd>{{ registration.BirthDay }}</dd>
              <dt>郵便番号</dt>
              <dd>{{ registration.ZipCode }}</dd>
              <dt>住所</dt>
              <dd>{{ registration.Part1OfAddress }}</dd>
              <dt>住所<span class="fs-08">（フリガナ）</span></dt>
              <dd>{{ registration.AddressKana }}</dd>
              <dt>住所<span class="fs-08">（建物名）</span></dt>
              <dd>{{ registration.Part2OfAddress }}</dd>
              <dt>住所<span class="fs-08">（その他）</span></dt>
              <dd>{{ registration.Part3OfAddress }}</dd>
              <dt>配送時連絡先</dt>
              <dd>{{ registration.UseTelKind }}</dd>
              <dt v-if="registration.UseTelKind == '携帯電話番号'">
                携帯電話番号
              </dt>
              <dd v-if="registration.UseTelKind == '携帯電話番号'">
                {{ registration.TelM }}
              </dd>
              <dt v-if="registration.UseTelKind == '自宅電話番号'">
                自宅電話番号
              </dt>
              <dd v-if="registration.UseTelKind == '自宅電話番号'">
                {{ registration.TelK }}
              </dd>
              <dt>FAX番号</dt>
              <dd>{{ registration.TelF }}</dd>
              <dt>スポンサーの氏名</dt>
              <dd>
                {{ registration.SpoName1 }}&emsp;{{ registration.SpoName2 }}
              </dd>
              <dt>スポンサーの氏名<span class="fs-08">（フリガナ）</span></dt>
              <dd>
                {{ registration.SpoNameKana1 }}&emsp;{{
                  registration.SpoNameKana2
                }}
              </dd>
              <dt>スポンサーの会員番号</dt>
              <dd>{{ registration.SpoNumber }}</dd>
              <dt>スポンサーの電話番号</dt>
              <dd>{{ registration.SpoTelNumber }}</dd>
              <dt>パスワード</dt>
              <dd>{{ registration.PassWord }}</dd>
              <dt>当社からの広告等のメール・FAX送信</dt>
              <dd>{{ registration.WantMail }}</dd>
              <dt>重要事項への同意</dt>
              <dd>同意する</dd>
            </dl>
          </form>
        </dl>
      </div>
      <div class="box-p-20 text-center mt-5">
        <router-link :to="{ path: '/registration' }" class="btn d-inline-block">
          申込者情報の登録へ戻る
        </router-link>
      </div>
    </div>
    <div class="box-p-20 text-center mb-5">
      <button v-on:click="putData" id="btnSend" type="button" class="confirm-01 clear">
        入会申込みを確定する
      </button>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
import ConfirmItem from "./components/ConfirmItem";
export default {
  components: {
    ConfirmItem,
  },
  mounted() {
    this.getData();
    window.scroll(0, 0);
  },
  data() {
    return {
      cart: [],
      delivery: [],
      registration: [],
      point:'0'
    };
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getDelivery",
        [false],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.cart = data.CartConfirm;
          this.delivery = data.DeliveryConfirm;
          this.registration = data.RegistrationConfirm;
          console.log(data)
          this.point = data.Point;
        });
    },
    putData(){
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putNewJoin",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push({
            path: "/registration/delivery/end",
          });
        });
    }
  },
};
</script>

<style scoped>
.cart_set dl {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cart_set dt {
  width: 300px;
  padding: 10px 15px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  background: #fafafa;
}
.cart_set dd {
  padding: 10px 15px;
  width: calc(100% - 300px);
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .cart_set dt,
  .cart_set dd {
    width: 100%;
  }
}
</style>